import {BasicSelect} from 'vue-search-select';
export default {
  name: 'push-ndc-details',
  components: {BasicSelect},
  props: [],
  data () {
    return {
      httpMethodList:[{value:'1',text:'DELETE'},{value:'2',text:'GET'},{value:'3',text:'HEAD'},{value:'4',text:'OPTIONS'},
      {value:'5',text:'PATCH'},{value:'6',text:'POST'},{value:'7',text:'PUT'}],
      httpMethodItem:{value:'6',text:'POST'},
      httpmethod:'POST',
      url:'',
      // url:'http://182.74.246.98:81/api/pushCentersList.php',
      headers:'',
      body:'',
      activeItem: 'headers'
    }
  },
  computed: {},
  mounted () {},
  methods: {
    selectedMethod(httpMethodItem){
      this.httpMethodItem = httpMethodItem
      this.httpMethod = httpMethodItem.text
    },
    sendCallToAPI() {
      axios({
          'method': this.method,
          'url': apiUrl.api_url_hubops + this.url,
          'data': this.body,
          'headers': {
            'Authorization': "authkey xB84JJ89Hd25"
          }
        })
        .then(result => {
          if (result) {
            console.log("result");
          } else {
            console.log("error");
          }
        }, error => {
          console.error(error)
        })
    },
  }
}



// WEBPACK FOOTER //
// ./src/views/components/pushNDCDetails/pushNDCDetails.js